import CircleEmptyInfoIcon from "./CircleEmptyInfoIcon.mjs";

/** @type {GlyphIcon} */
export default CircleEmptyInfoIcon;